import { Link } from "react-router-dom";

const MetaTraderWebTerminalContentThree = () => {
  return (
    <div className="how__work__platform">
      <div className="container">
        <div className="row">
          <div className="col-lg-6 col-md-12 col-sm-12 col-12">
            <div className="content-left">
              <h2>Trade Anytime, Anywhere</h2>
              <p>
                No matter where you are, the MetaTrader Web Terminal keeps you
                in control of your trading portfolio. Enjoy all essential
                trading tools, from interactive charts and technical indicators
                to live order management, directly from your browser. Perfect
                for traders who prefer a quick, hassle-free trading experience.
                With lightning-fast synchronization across devices, your trades,
                settings, and market data stay consistent wherever you log in.
                The platform is optimized for stability even on low-bandwidth
                connections, ensuring uninterrupted access during critical
                market moments. Whether you're traveling, working remotely, or
                simply stepping away from your main setup, you can trade
                confidently without missing a single opportunity.
              </p>
              <Link
                className="slide__btn dg__btn"
                to={process.env.PUBLIC_URL + "/company/contact"}
              >
                Launch Web Terminal
              </Link>
            </div>
          </div>
          <div className="col-lg-6 col-md-12 col-sm-12 col-12 sm__mt--40 md__mt--40">
            <div className="thumb-right">
              <img
                src={
                  process.env.PUBLIC_URL +
                  "/images/platforms/meta_trader_web_terminal/meta_trader_web_terminal_02.png"
                }
                alt="computer images"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MetaTraderWebTerminalContentThree;
